import React from 'react';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { FormField, Radio } from '@legalshield/adonis-ux-framework';

type Props<T extends FieldValues> = {
  control: Control<T>;
  name: Path<T>;
  label?: string;
  options: { title: string; value: string }[];
  required?: boolean;
};

const RadioField = <T extends FieldValues>({ control, name, label, options, required }: Props<T>) => (
  <Controller
    control={control}
    name={name}
    render={({ field, fieldState }) => (
      <FormField
        id={String(name)}
        label={label}
        required={required}
        status={fieldState.error ? 'invalid' : undefined}
        validationHint={fieldState.error?.message}
      >
        <div className="rnq-radio-group">
          {options.map((opt) => (
            <Radio
              key={opt.value}
              id={`${String(name)}-${opt.value}`}
              name={String(name)}
              value={opt.value}
              rightLabel={opt.title}
              checked={field.value === opt.value}
              onChange={() => field.onChange(opt.value)}
              onBlur={field.onBlur}
            />
          ))}
        </div>
      </FormField>
    )}
  />
);

export default RadioField;
